import select2 from 'select2';
import SimpleBar from 'simplebar';

export default function searchBar(element) {
  element.each(function(){
    $(this).select2();
  })
  $(document).on('select2:open', 'select', function() {
    $('.custom-tab .top').removeClass('open')
    $('.custom-tab .drop').slideUp(0);
    new SimpleBar($('.select2-results')[0]);
  });
}




// WEBPACK FOOTER //
// ./scripts/exports/selectFilters.js